import { RegionShared } from "@1games-ru/region-shared";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TfaMethod } from "@/core/constants/tfaMethod";
import { RootState } from "@/core/store";
import { Country } from "@/domains/auth/constants/country";
import { IS_DEV } from "@/domains/main/constants/other";

export interface AuthState {
  socialClub: string;
  emailConfirmed: boolean;
  signUp: {
    email: string;
    password: string;
    promoCode: string;
  };

  pinConfirmed: boolean;

  resetPassword: { method: TfaMethod | null };
  enableTfa: typeof RegionShared.Backend.Responses.AuthResponse;
  enableResetPasswordMethods: TfaMethod[];

  countries: [{ country: Country; short: string; code: string }];
}

const initialState: AuthState = {
  socialClub: "",
  emailConfirmed: false,
  signUp: {
    email: "",
    password: "",
    promoCode: "",
  },
  pinConfirmed: false,

  resetPassword: {
    method: null,
  },

  enableTfa: IS_DEV
    ? {
        isGoogleEnabled: true,
        isSmsEnabled: true,
        isEmailEnabled: true,
        email: "asdasd@asdasd.ru",
        phoneNumber: "+70000000000",
      }
    : {
        isGoogleEnabled: false,
        isSmsEnabled: false,
        isEmailEnabled: false,
        email: "",
        phoneNumber: "",
      },

  enableResetPasswordMethods: IS_DEV
    ? [TfaMethod.AUTHENTICATOR, TfaMethod.EMAIL, TfaMethod.SMS]
    : [],

  countries: [{ country: Country.Russia, short: "RU", code: "+7" }],
};

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    setResetPasswordMethod: (state, action: PayloadAction<TfaMethod | null>) => {
      state.resetPassword.method = action.payload;
    },
    setEmailConfirmed: (state, action: PayloadAction<boolean>) => {
      state.emailConfirmed = action.payload;
    },
    setPinConfirmed: (state, action: PayloadAction<boolean>) => {
      state.pinConfirmed = action.payload;
    },
    setSignUp: (state, action: PayloadAction<AuthState["signUp"]>) => {
      state.signUp = action.payload;
    },
    setEnableResetPasswordMethods: (state, action: PayloadAction<TfaMethod[]>) => {
      state.enableResetPasswordMethods = action.payload;
    },
    setEnableTfa: (state, action: PayloadAction<Partial<AuthState["enableTfa"]>>) => {
      state.enableTfa = { ...state.enableTfa, ...action.payload };
    },
    setSocialClub: (state, action: PayloadAction<string>) => {
      state.socialClub = action.payload;
    },
  },
});

export const resetPasswordMethodSelector = (state: RootState) => state.auth.resetPassword.method;
export const sighUpSelector = (state: RootState) => state.auth.signUp;
export const emailConfirmedSelector = (state: RootState) => state.auth.emailConfirmed;
export const pinConfirmedSelector = (state: RootState) => state.auth.pinConfirmed;
export const countriesSelector = (state: RootState) => state.auth.countries;
export const socialClubSelector = (state: RootState) => state.auth.socialClub;
export const enableTfaSelector = (state: RootState) => state.auth.enableTfa;
export const enableResetPasswordMethodsSelector = (state: RootState) =>
  state.auth.enableResetPasswordMethods;

export const authReducer = authSlice.reducer;
export const {
  setEmailConfirmed,
  setPinConfirmed,
  setResetPasswordMethod,
  setSignUp,
  setEnableResetPasswordMethods,
  setEnableTfa,
  setSocialClub,
} = authSlice.actions;
